import React from 'react'

const AndroidBasics = () => {
  return (
    <div>
      {/* collapseSixtyOne */}
      <div className="accordion-item mb-2">
          <h2 className="accordion-header" id="headingSixtyOne">
              <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSixtyOne" aria-expanded="false" aria-controls="collapseSixtyOne">
                  Android Basics <span className="toggle-icon ms-auto"></span>
              </button>
          </h2>
          <div id="collapseSixtyOne" className="accordion-collapse collapse" aria-labelledby="headingSixtyOne" data-bs-parent="#accordionCourses">
              <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                  <strong>Introduction</strong>
                  <ul>
                      <li>Android Virtual Device</li>
                      <li>Understanding Android Studio</li>
                      <li>Accessing Components</li>
                      <li>Accessing UI Components</li>
                      <li>Using Find View By Id</li>
                      <li>Directly By Component Name</li>
                  </ul>
                  <strong>Button</strong><br/>
                  <strong>Calling functions using</strong>
                  <ul>
                      <li>On Click</li>
                      <li> Set ONCLICKLISTENER</li>
                  </ul>
                  <strong>Views</strong><br/>
                  <strong>Image Views</strong><br/>
                  <ul>
                      <li>Using image resources and fitting them to screen</li>
                  </ul>
                  <strong>Switch</strong><br/>
                  <ul>
                      <li>An on/off trigger</li>
                  </ul>
                  <strong>Edit Text</strong><br/>
                  <ul>
                      <li>Entering/Modifying text into UI.</li>
                      <li>EDITTEXT Events</li>
                  </ul>
              </div>
          </div>
      </div>

    </div>
  )
}

export default AndroidBasics